function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityClubLoungeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 20v1.25a2 2 0 00-2 2V30h26v-6.75a2 2 0 00-2-2V20a3 3 0 00-3-3H8a3 3 0 00-3 3zm3-1a1 1 0 00-1 1v1.25a2 2 0 012 2v1.25h14v-1.25a2 2 0 012-2V20a1 1 0 00-1-1H8zm19 9v-4.75h-2v3.25H7v-3.25H5V28h22z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 6l-2.588 1.412L26 10l-1.412-2.588L22 6l2.588-1.412L26 2l1.412 2.588L30 6zM8 7L6.059 8.059 5 10 3.941 8.059 2 7l1.941-1.059L5 4l1.059 1.941L8 7zM9 13l-1.294.706L7 15l-.706-1.294L5 13l1.294-.706L7 11l.706 1.294L9 13z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4.083V2h-2v2.083A6.002 6.002 0 0016 16a6 6 0 001-11.917zM20 10c0 .345-.044.68-.126 1h-1.412a12.898 12.898 0 000-2h1.412c.082.32.126.655.126 1zm-5.458 1h2.916a11.862 11.862 0 000-2h-2.916a11.863 11.863 0 000 2zm4.923-3H18.34a8.774 8.774 0 00-.373-1.483A4.02 4.02 0 0119.465 8zM16.95 6.65a3.804 3.804 0 00-.296-.597 4.027 4.027 0 00-1.308 0 3.804 3.804 0 00-.296.597A7.178 7.178 0 0014.674 8h2.652a7.178 7.178 0 00-.376-1.35zm0 6.7c.153-.382.281-.839.376-1.35h-2.652c.095.511.223.968.376 1.35a3.8 3.8 0 00.296.597 4.02 4.02 0 001.308 0 3.8 3.8 0 00.296-.597zM18.34 12a8.775 8.775 0 01-.372 1.483A4.02 4.02 0 0019.465 12H18.34zm-4.802-3a12.898 12.898 0 000 2h-1.412a4.01 4.01 0 010-2h1.412zm.494-2.483A8.774 8.774 0 0013.659 8h-1.124a4.02 4.02 0 011.497-1.483zM13.659 12h-1.124a4.02 4.02 0 001.497 1.483A8.775 8.775 0 0113.659 12z",
    fill: props.color
  }));
}

export default SvgIconFacilityClubLoungeFilled;